import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/header"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

export type RecentSearchListItemProps = {
    children: React.ReactNode
    handleClick: () => void
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
}

export const RecentSearchListItem = memo(({children, handleClick, templating}: RecentSearchListItemProps) => {
    const ListItem = useTemplatedComponent(templating, MANIFEST)
    return (
        <Suspense>
            <ListItem data-testid="header-recent-search-item" handleClick={handleClick}>
                {children}
            </ListItem>
        </Suspense>
    )
})
RecentSearchListItem.displayName = "RecentSearchListItem"

export default connect(RecentSearchListItem)
